import {
  DashboardOutlined,
  AppstoreOutlined,
  PlusOutlined,
  TeamOutlined,
  UserOutlined,
  CarOutlined,
  HistoryOutlined,
  SwapOutlined,
  DollarOutlined,
  CustomerServiceOutlined,
  SettingOutlined,
  WalletOutlined,
  TrophyOutlined,
  BankOutlined,
  SyncOutlined,
  UserSwitchOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// Configuration des pages avec titre, description, icône et couleur
const pageConfig = {
  // Dashboard
  '/dashboard': {
    title: 'Tableau de Bord',
    description: "Vue d'ensemble des activités TIGOON Connect",
    icon: DashboardOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },

  // Gestion Services
  '/dashboard/categories': {
    title: 'Gestion des Services',
    description: 'Liste des catégories de services disponibles',
    icon: AppstoreOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },
  '/dashboard/ajouter-categorie': {
    title: 'Nouvelle Catégorie',
    description: 'Ajoutez une nouvelle catégorie de service',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },

  // Inscription
  '/dashboard/partenaires': {
    title: 'Partenaires TIGOON',
    description: 'Liste des partenaires inscrits sur la plateforme',
    icon: TeamOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },
  '/dashboard/partenaire': {
    title: 'Détail Partenaire',
    description: 'Informations détaillées du partenaire',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },
  '/dashboard/vehicules': {
    title: 'Véhicules',
    description: 'Liste des véhicules enregistrés',
    icon: CarOutlined,
    gradient: 'linear-gradient(135deg, #13c2c2 0%, #36cfc9 50%, #87e8de 100%)',
    shadowColor: 'rgba(19, 194, 194, 0.3)'
  },
  '/dashboard/chauffeurs': {
    title: 'Chauffeurs YANDEX',
    description: 'Liste des chauffeurs synchronisés avec Yandex',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%)',
    shadowColor: 'rgba(24, 144, 255, 0.3)'
  },
  '/dashboard/chauffeur': {
    title: 'Détail Chauffeur',
    description: 'Informations détaillées du chauffeur',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%)',
    shadowColor: 'rgba(24, 144, 255, 0.3)'
  },

  // Historique Modifications
  '/dashboard/historique-numeros': {
    title: 'Historique des Numéros',
    description: 'Suivi des modifications de numéros de téléphone',
    icon: HistoryOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },
  '/dashboard/historique-vehicules-modifies': {
    title: 'Historique Véhicules',
    description: 'Suivi des modifications de véhicules',
    icon: CarOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },

  // Transactions
  '/dashboard/historique-transferts': {
    title: 'Transferts UV',
    description: 'Historique des transferts UV entre partenaires',
    icon: SwapOutlined,
    gradient: 'linear-gradient(135deg, #eb2f96 0%, #f759ab 50%, #ffadd2 100%)',
    shadowColor: 'rgba(235, 47, 150, 0.3)'
  },
  '/dashboard/historique-sos-credit': {
    title: 'SOS Crédits',
    description: 'Historique des demandes de crédit SOS',
    icon: DollarOutlined,
    gradient: 'linear-gradient(135deg, #f5222d 0%, #ff4d4f 50%, #ff7875 100%)',
    shadowColor: 'rgba(245, 34, 45, 0.3)'
  },

  // Assistance
  '/dashboard/demandes-assistances': {
    title: 'Demandes d\'Assistance',
    description: 'Gestion des demandes d\'aide des partenaires',
    icon: CustomerServiceOutlined,
    gradient: 'linear-gradient(135deg, #faad14 0%, #ffc53d 50%, #ffd666 100%)',
    shadowColor: 'rgba(250, 173, 20, 0.3)'
  },

  // Administration
  '/dashboard/gestion-admins': {
    title: 'Administrateurs',
    description: 'Gestion des comptes administrateurs',
    icon: TeamOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },
  '/dashboard/ajouter-admin': {
    title: 'Nouvel Administrateur',
    description: 'Créer un nouveau compte administrateur',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },

  // Wallet & Points
  '/dashboard/wallet': {
    title: 'Wallet',
    description: 'Gestion du portefeuille et transactions',
    icon: WalletOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },
  '/dashboard/historique-points': {
    title: 'Historique des Points',
    description: 'Suivi des mouvements de points',
    icon: DollarOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },

  // Promotions
  '/dashboard/historique-promotions': {
    title: 'Promo Dimanche',
    description: 'Historique des promotions dimanche',
    icon: TrophyOutlined,
    gradient: 'linear-gradient(135deg, #faad14 0%, #ffc53d 50%, #ffd666 100%)',
    shadowColor: 'rgba(250, 173, 20, 0.3)'
  },
  '/dashboard/toutes-operations': {
    title: 'Opérations',
    description: 'Historique de toutes les opérations',
    icon: FileTextOutlined,
    gradient: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%)',
    shadowColor: 'rgba(24, 144, 255, 0.3)'
  },

  // Achète ton terrain
  '/dashboard/sites': {
    title: 'Sites Immobiliers',
    description: 'Gestion des sites du programme Achète ton terrain',
    icon: BankOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },
  '/dashboard/site': {
    title: 'Détail du Site',
    description: 'Informations et lots du site sélectionné',
    icon: BankOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },
  '/dashboard/ajout-site': {
    title: 'Nouveau Site',
    description: 'Ajouter un nouveau site immobilier',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },
  '/dashboard/souscripteurs': {
    title: 'Souscripteurs',
    description: 'Liste des souscriptions au programme terrain',
    icon: TeamOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },
  '/dashboard/souscripteur': {
    title: 'Détail Souscripteur',
    description: 'Informations détaillées de la souscription',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },

  // Configuration
  '/dashboard/settings': {
    title: 'Paramètres',
    description: 'Configuration système de la plateforme',
    icon: SettingOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },

  // Synchronisation
  '/dashboard/sync-chauffeurs': {
    title: 'Chauffeurs Non Liés',
    description: 'Chauffeurs Tigoon non liés à un profil Yandex',
    icon: SyncOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },
  '/dashboard/sync-vehicules': {
    title: 'Véhicules Manquants',
    description: 'Véhicules Yandex non présents dans Tigoon',
    icon: CarOutlined,
    gradient: 'linear-gradient(135deg, #13c2c2 0%, #36cfc9 50%, #87e8de 100%)',
    shadowColor: 'rgba(19, 194, 194, 0.3)'
  },
  '/dashboard/sync-anciens-chauffeurs': {
    title: 'Anciens Chauffeurs',
    description: 'Chauffeurs Yandex non inscrits sur Tigoon',
    icon: UserSwitchOutlined,
    gradient: 'linear-gradient(135deg, #eb2f96 0%, #f759ab 50%, #ffadd2 100%)',
    shadowColor: 'rgba(235, 47, 150, 0.3)'
  },

  // Profil
  '/dashboard/profile': {
    title: 'Mon Profil',
    description: 'Gérez vos informations personnelles',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%)',
    shadowColor: 'rgba(24, 144, 255, 0.3)'
  },
};

// Fonction pour obtenir la config d'une page
export const getPageConfig = (pathname) => {
  // Correspondance exacte d'abord
  if (pageConfig[pathname]) {
    return pageConfig[pathname];
  }

  // Pour les routes avec paramètres (ex: /dashboard/partenaire/123)
  const pathParts = pathname.split('/');
  if (pathParts.length >= 3) {
    const basePath = `/${pathParts[1]}/${pathParts[2]}`;
    if (pageConfig[basePath]) {
      return pageConfig[basePath];
    }
  }

  // Config par défaut
  return {
    title: 'TIGOON Connect',
    description: 'Backoffice de gestion',
    icon: DashboardOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  };
};

export default pageConfig;
